import { z } from 'zod';

export const IMPORT_FORMATS = ['csv', 'json', 'text'] as const;
export type ImportFormat = (typeof IMPORT_FORMATS)[number];

export const TradeLinkImportSchema = z.object({
  clientId: z.string().uuid('Выберите клиента'),
  format: z.enum(IMPORT_FORMATS),
});

export type TradeLinkImportInput = z.infer<typeof TradeLinkImportSchema>;
